export default {
  submitText: '提交',
  emptyBtn: false,
  group: [
    {
      label: '现住房间',
      prop: 'group1',
      column: [
        {
          label: '入住房间',
          type: 'tree',
          search: true,
          editDisabled: true,
          disabled: true,
          dicUrl: '/api/v4ward/department/getDepartmentByPropertyNameTree',
          props: {
            label: 'propertyName',
            value: 'id',
          },
          prop: 'departmentId',
          hide: true,
          rules: [
            {
              required: true,
              message: '请选择入住房间',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '室友',
          prop: 'roommateName',
          disabled: true,
        },
        {
          label: '房间租金',
          type: 'number',
          precision: '2',
          prop: 'rentAmount',
          disabled: true,
        },
        {
          label: '减免金额',
          type: 'number',
          precision: '2',
          prop: 'derateMoney',
          disabled: true,
        },
        {
          label: '电费止码',
          maxlength: 12,
          prop: 'electricityEedNum',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
            {
              required: true,
              message: '请输入电费止码',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '水费止码',
          maxlength: 12,
          prop: 'waterEedNumber',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
      ],
    },
    {
      label: '更换至',
      prop: 'group2',
      column: [
        {
          label: '入住房间',
          type: 'tree',
          search: true,
          editDisabled: true,
          dicUrl: '/api/v4ward/department/getDepartmentByPropertyNameTree',
          props: {
            label: 'propertyName',
            value: 'id',
          },
          prop: 'departmentRoomChangeId',
          hide: true,
          rules: [
            {
              required: true,
              message: '请选择入住房间',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '室友',
          prop: 'roomChangeRoommateName',
          disabled: true,
        },
        {
          label: '房间租金',
          type: 'number',
          precision: '2',
          prop: 'changeRentAmount',
          disabled: true,
        },
        {
          label: '减免金额',
          type: 'number',
          precision: '2',
          prop: 'derateMoney',
          disabled: true,
        },
        {
          label: '电费起码',
          maxlength: 12,
          prop: 'electricityBeginRoomChangeNum',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
            {
              required: true,
              message: '请输入电费起码',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '水费起码',
          maxlength: 12,
          prop: 'waterBeginRoomChangeNumber',
          rules: [
            {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
          ],
        },
      ],
    },
  ],
};
